/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

// project imports
import { Header, Sidebar, Footer, HelpSideBar } from '.';
import AppRouter from 'features/routers/AppRouter';
import { logout } from 'shared/settings/auth';
import store from 'features/store';
import { SupportWidgetController } from 'features/components/base/support/SupportWidgetController';

// style imports
import './AppLayout.scss';

/**
 * main page layout after login is made
 * 
 * @param props
 * 
 * @returns renders the base layout after login
 * 
**/

class AppLayout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            path: '',
            helpSideBarToggle: false,
            logoutModal: true,
            sessionModal: true
        };
    }

    componentDidUpdate() {
        if (this.state.path !== this.props.history.location.pathname) {
            this.setState({ path: this.props.history.location.pathname });
            this.sidebarToggle();
        }
    }

    /* this is used only in tablet and mobile devices to open or close sidebar */
    sidebarToggle = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: false });
    };

    helpSideBarHandle = (event) => {
        this.setState({ helpSideBarToggle: !this.state.helpSideBarToggle });
    };

    /* closes the logout modal box */
    logoutUser = (event) => {
        if (event) {
            logout(this.props.history);
        }
        store.dispatch({ type: 'urlNavigate', payload: '/' });
        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: false });
    };

    signIn = (event) => {
        if (event) {
            logout(this.props.history);
        }
        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: false });
    }

    render() {

        return (
            <div className="d-flex flex-column layout">
                <div className="top-layout">
                    <Header {...this.props} onClick={this.helpSideBarHandle} />
                </div>
                <div className="d-flex flex-row middle-layout">
                    {
                        this.props['sidebar'] ?
                            <div className={`${this.props.toggleSidebar ? 'd-flex' : 'd-none'}  d-lg-flex flex-row sidebar-layout`}
                                onClick={this.sidebarToggle}>
                                <Sidebar {...this.props} />
                            </div> :
                            null
                    }
                    <div className={`d-flex flex-column content-layout ${this.props.sidebar ? 'content-layout-sidebar' : ''}`}>
                        <AppRouter />
                    </div>
                </div>
                <div className={`${this.state.helpSideBarToggle ? 'd-flex' : 'd-none'} flex-row-reverse help-sidebar-layout`}>
                    <HelpSideBar onClick={this.helpSideBarHandle}></HelpSideBar>
                </div>
                {
                    this.props['footer'] ?
                        <div className="bottom-layout">
                            <Footer />
                        </div> :
                        null

                }
                <SupportWidgetController
                    pathname={this.props.history.location.pathname}
                    userId={this.props.user?.id}
                />
                <Modal centered show={this.props.logoutModal} size="sm" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Are you sure to signout?
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '60px' }} onClick={() => this.logoutUser(false)}>No</Button>
                                <Button variant="secondary mx-2" style={{ width: '60px' }} onClick={() => this.logoutUser(true)}>Yes</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.props.sessionModal} size="sm" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Your session has expired. Please refresh the screen or logout and log back in. 
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => this.signIn(true)}>Sign In</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(AppLayout);
